import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons'; // Import the edit icon
import '../../../../src/AssetStatusForm.scss'

interface TableProps {
    data: any[];
    handleEditClick: (rowData: any) => void
}

export const AlarmsTable: React.FC<TableProps> = ({ data, handleEditClick }) => {

    // Function to determine the color based on severity
    const getSeverityColor = (severity) => {
        switch (severity?.toString()) {
            case "critical":
                return "1px solid var(--Error-Red-700, #B42318)"; // Red border for critical
            case "high":
                return "1px solid var(--Colors-Red, #FF3B30)"; // Orange border for high
            case "medium":
                return "1px solid var(--Secondary-Orange-400, #FB743C)"; // Yellow border for medium
            case "low":
                return "1px solid var(--Warning-Yellow-400, #FDB022)"; // Green border for low
            default:
                return "border-gray-500"; // Default gray for unknown
        }
    };

    return (
        <div className="mx-auto w-full">
            <div className="bg-gray-600">
                <div className="flow-root">
                    <div className="overflow-x-auto border border-darkcolor-600 rounded-lg">
                        <div style={{  maxHeight: "32.5vw",overflowY: "auto" }}>
                            <table className="min-w-full divide-y divide-darkcolor-400">
                                <thead className="sticky top-[-4px] bg-darkcolor-600">
                                    <tr>
                                        <th className="pl-2 py-4 text-sm text-gray-300 text-left">Alarms</th> {/* New column for severity */}
                                        <th className="px-3 py-4 text-sm text-gray-300 text-left"></th>
                                        <th className="py-4 text-sm text-gray-300 text-left"></th>
                                        <th className="py-4 text-sm text-gray-300 text-left"></th>
                                        <th className="py-4 text-sm text-gray-300 text-left"></th> {/* New column for actions */}
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-darkcolor-400 bg-darkcolor-600">
                                    {data?.map((item, index) => (
                                        <tr key={index} className="hover:bg-darkcolor-400">
                                            <td className="whitespace-nowrap px-3 py-4">
                                                <div
                                                    className={`w-4 h-4 rounded-full border-2 bg-transparent`}
                                                    style={{ border: getSeverityColor(item.severity) }}
                                                ></div> {/* Round circle with border color based on severity */}
                                            </td>
                                            <td className="whitespace-nowrap pr-2 py-2 text-sm text-gray-300 text-left">
                                                {item.alarmName}
                                            </td>
                                            <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-300 text-left">
                                                {`${item.dataPoint} ${item.condition} ${item.value}`}
                                            </td>
                                            <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-300 text-left">
                                                {item.status}
                                            </td>
                                            <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-300 text-left">
                                                {/* FontAwesome Edit Icon */}
                                                <button
                                                    onClick={() => handleEditClick(item)}
                                                    className="text-blue-500 hover:text-blue-700"
                                                >
                                                    <FontAwesomeIcon icon={faEdit} /> {/* FontAwesome edit icon */}
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

};
